import {
  REGEX_EMAIL_ADDRESS,
  REGEX_PHONE_NUMBER,
  REGEX_NUMERIC_ONLY,
  REGEX_ALPHA_ONLY,
} from '../constants';

const marOpsValidator = {
  validateNotEmpty(inputStr) {
    return (inputStr !== undefined && inputStr !== '' ? true : 'This field is required');
  },
  validateAlpha(inputStr) {
    return (REGEX_ALPHA_ONLY.test(inputStr.toString()) ? true : 'Must contain only letters');
  },
  validateNumeric(inputStr) {
    return (REGEX_NUMERIC_ONLY.test(inputStr.toString()) ? true : 'Must contain only numbers');
  },
  validatePhone(inputStr) {
    return (REGEX_PHONE_NUMBER.test(inputStr.toString()) ? true : 'Must be a valid phone number');
  },
  validateEmail(inputStr) {
    return (REGEX_EMAIL_ADDRESS.test(inputStr.toString()) ? true : 'Must be a valid email address');
  },
  validateMinLength(inputStr, minLength) {
    return (inputStr.length >= minLength ? true : `Must have at least ${minLength} characters`);
  },
  validateMaxLength(inputStr, maxLength) {
    return (inputStr.length <= maxLength ? true : `Must be less than ${maxLength} characters`);
  },
  validateAll(formRefs, sendObject) {
    const validationTests = Object.entries(formRefs).map((vueRef) => {
      const k = vueRef[0];
      const itemValue = sendObject[k];
      const rawRules = formRefs[k].rules;
      const rules = (rawRules !== undefined ? rawRules.toString().split('|') : '');
      let isValid = true;
      if (rules.length > 0) {
        rules.forEach((item) => {
          switch (item) {
            case 'required':
              isValid = marOpsValidator.validateNotEmpty(itemValue);
              break;

            case 'email':
              isValid = marOpsValidator.validateEmail(itemValue);
              break;

            case 'phone':
              isValid = marOpsValidator.validatePhone(itemValue);
              break;

            default:
              isValid = true;
              break;
          }

          if (isValid !== true) {
            const elWrapper = formRefs[k];
            elWrapper.errorMessage = isValid;
            return false;
          }
          return true;
        });
      }
      return isValid;
    });
    return validationTests;
  },
};

export default marOpsValidator;
